import { useEffect, useRef } from 'react'

/**
 * Scrolls to the first form field with an error when validation fails,
 * or to the error message div when a server error occurs.
 * @param {Object} errors - React Hook Form errors object
 * @param {string|null} serverError - Server/submission error message
 */
export function useScrollToError(errors, serverError = null) {
  const prevServerError = useRef(null)

  // Scroll to field errors (React Hook Form validation)
  useEffect(() => {
    const errorKeys = Object.keys(errors)
    if (errorKeys.length > 0) {
      const firstErrorKey = errorKeys[0]
      const firstErrorField = document.getElementById(firstErrorKey)
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' })
        firstErrorField.focus()
      }
    }
  }, [errors])

  // Scroll to server error message
  useEffect(() => {
    // Only scroll if serverError just appeared (wasn't there before)
    if (serverError && prevServerError.current !== serverError) {
      const errorMessageDiv = document.querySelector('.error-message')
      if (errorMessageDiv) {
        errorMessageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
    prevServerError.current = serverError
  }, [serverError])
}
